import { create } from "zustand";

export interface BasaDocumentRequest {
  readonly href: string;
  readonly quotes: ReadonlyArray<string>;
}

interface BasaDocumentDialogStore {
  request: BasaDocumentRequest | null;
  open: (request: BasaDocumentRequest) => void;
  close: () => void;
}

export const useBasaDocumentDialogStore = create<BasaDocumentDialogStore>((set) => ({
  request: null,
  open: (request) => set({ request }),
  close: () => set({ request: null }),
}));
